export default __webpack_public_path__ + "static/media/shop.2c09f028.svg";